import { ReactNode } from 'react';
import { Button, DropdownMenu, DropdownMenuItem, SearchField, TooltipNew } from 'ui';
import { FilterLinesGrayIcon } from 'ui/icons';

interface MeetingsToolbarProps {
  searchValue: string;
  selectedSortLabel: string;
  sortOptions: DropdownMenuItem<ReactNode>[];
  isSearchLoading: boolean;
  isAdmin: boolean;
  onSearchChange: (value: string) => void;
  onScheduleMeeting: () => void;
}

export const MeetingsToolbar = ({
  searchValue,
  selectedSortLabel,
  sortOptions,
  isSearchLoading,
  isAdmin,
  onSearchChange,
  onScheduleMeeting,
}: MeetingsToolbarProps) => {
  return (
    <div className="flex items-center justify-between gap-4 px-0 py-4">
      <div className="flex items-center">
        <DropdownMenu
          className="w-[220px]"
          containerClassName="w-fit"
          placement="bottom"
          button={
            <div className="flex h-10 w-fit items-center gap-2 rounded px-2 text-sm leading-[22px] text-gray-900 hover:bg-gray-100">
              <img src={FilterLinesGrayIcon} alt="sort" className="h-5 w-5" />
              <span className="text-gray-500">Sort:</span>
              <span className="font-medium">{selectedSortLabel}</span>
            </div>
          }
          items={sortOptions}
        />
      </div>
      <div className="flex items-center gap-4">
        <SearchField
          className="!w-[240px]"
          placeholder="Search"
          value={searchValue}
          onChange={onSearchChange}
          isLoading={isSearchLoading}
          allowClear
        />
        <div className="w-fit">
          <TooltipNew
            text="Only users with Admin role can schedule new meetings."
            disabled={isAdmin}
          >
            <Button onClick={onScheduleMeeting} variant="primary" disabled={!isAdmin}>
              Schedule Meeting
            </Button>
          </TooltipNew>
        </div>
      </div>
    </div>
  );
};
